import { DeltaStatic } from "quill"

import { ReactQuillStyled } from "./styles"

interface ITextEditor {
  body: {
    ops: {
      [k: string]: any
    }[]
  }
}

export const TextEditor = ({ body }: ITextEditor) => {
  return (
    <ReactQuillStyled readOnly theme="bubble" value={body as DeltaStatic} />
  )
}
